import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';


export interface WebchatRadioGroupOption<T = string | number | boolean> {
    value: T;
    labelKey?: string;
    labelIcon?: React.ReactNode;
}

interface WebchatRadioGroupProps<T = string | number | boolean> {
    name: string;
    options: WebchatRadioGroupOption<T>[];
    selectedValue?: T;
    onChange: (value: T) => void;
    "aria-labelledby"?: string;
}

const WebchatRadioGroup = <T extends string | number | boolean>(props: WebchatRadioGroupProps<T>) => {
    const { name, options, selectedValue, "aria-labelledby": ariaLabelledby, onChange } = props;

    const intl = useIntl();

    return (
        <fieldset role="radiogroup"
                  aria-labelledby={ariaLabelledby}
                  className={classNames(
                      "flex items-center",
                      options.length === 3 ? "gap-6" : "gap-4"
                  )}
        >
            {options.map(option => (
                <label key={option.value.toString()}
                       className={classNames(
                           "flex gap-1.5 items-center cursor-pointer",
                           options.length === 3 ? "w-[40px]" : "w-[96px]"
                       )}
                >
                    <input type="radio"
                           name={name}
                           className="input-radio-chat42 size-4"
                           checked={selectedValue === option.value}
                           onChange={() => onChange(option.value)}
                    />
                    <div className="label-input-grid-label input-label">
                        {option.labelKey ? intl.formatMessage({ id: option.labelKey }) : option.labelIcon}
                    </div>
                </label>
            ))}
        </fieldset>
    );
};

export default WebchatRadioGroup;
